<template>
    <page>
        <div class="shadow-25 column items-center justify-center central-content">
            <v-header :title="$t('export file')" icon="cloud download"></v-header>
            <card width="400px" style="margin: 0 auto;">

                <form class="q-pt-xs gutter-xs row" method="post" target="_blank"
                :action="`${config.appUrl}/audit/export`">
                    <input type="hidden" name="partial" :value="partial">
                    <input type="hidden" name="from_date" :value="from_date">
                    <input type="hidden" name="to_date" :value="to_date">
                    <!--<v-checkbox path="partial"
                                v-model="partial"
                                :label="$t('download only the audits registered after the last export.')"
                                :form="form"
                                class="col-12">
                    </v-checkbox>-->

                    <v-datetime path="from_date"
                                v-model="from_date"
                                :label="$t('from date')"
                                format-data="YYYY-MM-DD"
                                format="DD-MM-YYYY"
                                :form="form"
                                class="col-md-12 col-xs-12">
                    </v-datetime>

                    <v-datetime path="to_date"
                                v-model="to_date"
                                :label="$t('to date')"
                                format-data="YYYY-MM-DD"
                                format="DD-MM-YYYY"
                                :form="form"
                                class="col-md-12 col-xs-12">
                    </v-datetime>


                    <!-- Submit Button -->
                    <div class="row justify-center col-12 q-mt-md">
                        <v-button outline
                                  :label="$t('download')"
                                  icon="cloud download"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  type="submit">
                        </v-button>
                    </div>

                </form>

            </card>
        </div>
    </page>
</template>

<script>
    export default {
        middleware: 'auth',

        metaInfo() {
            return {title: this.$T('export file')}
        },

        data() {
            return {
                config,
                partial: false,
                from_date: '',
                to_date: '',
                form: {}
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/audit/export.vue